/*
sai krishna 01/19/2023 2698197526 added  batch table for open
*/

import React from 'react';
import LandingPage from '../../../LandingPage';
import WorkQueueListTable from './WorkQueueListTable';
const WorkQueueList = () => {
  return (
    <LandingPage title={'Operations'} showTabs={true}>
      <div className={`global-field-dash-board`} role="main">
        <WorkQueueListTable />
      </div>
    </LandingPage>
  );
};

export default WorkQueueList;
